import { Box } from "theme-ui"
import notif from "./notif.png"

// interface for declaration types in array
interface notificationStructure {
 id: number
 date: string
 user_name: string
 user_message: string
}
// getting props from notification component
interface Types {
 notificationData: notificationStructure[]
 deleteNotification: (_id: number) => void
}
export const NotificationMenu = ({ notificationData, deleteNotification }: Types) => {
 return (
  <Box color="text" bg="highlight" className="max-h-[60vh] overflow-y-auto border rounded-b-lg">
   {/* =============== NotificationMenu start ================ */}
   <ul className="w-96 px-4  py-3">
    <div className="flex my-3 justify-between items-center">
     <div className="flex gap-2 items-center">
      <svg
       xmlns="http://www.w3.org/2000/svg"
       width="24"
       height="24"
       viewBox="0 0 24 24"
       fill="white"
      >
       <path
        d="M12.0186 2.91016C8.70862 2.91016 6.01862 5.60016 6.01862 8.91016V11.8002C6.01862 12.4102 5.75862 13.3402 5.44862 13.8602L4.29862 15.7702C3.58862 16.9502 4.07862 18.2602 5.37862 18.7002C9.68862 20.1402 14.3386 20.1402 18.6486 18.7002C19.8586 18.3002 20.3886 16.8702 19.7286 15.7702L18.5786 13.8602C18.2786 13.3402 18.0186 12.4102 18.0186 11.8002V8.91016C18.0186 5.61016 15.3186 2.91016 12.0186 2.91016Z"
        stroke="#0D0D0D"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
       />
       <path
        d="M13.8719 3.19994C13.5619 3.10994 13.2419 3.03994 12.9119 2.99994C11.9519 2.87994 11.0319 2.94994 10.1719 3.19994C10.4619 2.45994 11.1819 1.93994 12.0219 1.93994C12.8619 1.93994 13.5819 2.45994 13.8719 3.19994Z"
        stroke="#0D0D0D"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
       />
       <path
        d="M15.0195 19.0601C15.0195 20.7101 13.6695 22.0601 12.0195 22.0601C11.1995 22.0601 10.4395 21.7201 9.89953 21.1801C9.35953 20.6401 9.01953 19.8801 9.01953 19.0601"
        stroke="#0D0D0D"
        strokeWidth="1.5"
        strokeMiterlimit="10"
       />
      </svg>
      <li className="font-bold">Notifications</li>
     </div>
     <div className="relative flex justify-center items-center">
      <p className="text-red px-4 py-2">{notificationData.length}</p>
      <div className="absolute bg-medium-red rounded-lg inset-0 opacity-40"></div>
     </div>
    </div>
    {notificationData.length !== 0 ? (
     <div>
      {notificationData.map((notification, index) => (
       <div key={index} className=" my-3 ">
        <div className="flex justify-between items-center">
         <div className="flex gap-2 items-center">
          <img className="w-2" src={notif} alt="notif" />
          <li className="font-medium">{notification.user_name}</li>
         </div>
         <div className=" flex justify-center gap-1 items-center">
          <p className="text-[10px] opacity-60 py-2">{notification.date}</p>
          <button onClick={() => deleteNotification(notification.id)}>
           <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
            <path
             fillRule="evenodd"
             clipRule="evenodd"
             d="M10.9889 2.8401C11.1996 2.8401 11.375 3.01506 11.375 3.23768V3.44351C11.375 3.66072 11.1996 3.84109 10.9889 3.84109H2.01167C1.80042 3.84109 1.625 3.66072 1.625 3.44351V3.23768C1.625 3.01506 1.80042 2.8401 2.01167 2.8401H3.59101C3.91184 2.8401 4.19104 2.61206 4.26321 2.29032L4.34592 1.9209C4.47446 1.4177 4.89748 1.0835 5.38161 1.0835H7.61839C8.09726 1.0835 8.52502 1.4177 8.64881 1.89436L8.73732 2.28978C8.80896 2.61206 9.08816 2.8401 9.40951 2.8401H10.9889ZM10.1866 10.3643C10.3515 8.82756 10.6402 5.17677 10.6402 5.13993C10.6507 5.02835 10.6144 4.92273 10.5422 4.83769C10.4648 4.75806 10.3668 4.71094 10.2588 4.71094H2.74558C2.63706 4.71094 2.5338 4.75806 2.46216 4.83769C2.38946 4.92273 2.35364 5.02835 2.35891 5.13993C2.35987 5.1467 2.37023 5.2753 2.38755 5.49029C2.46448 6.44538 2.67876 9.1055 2.81722 10.3643C2.91521 11.2916 3.52366 11.8744 4.40499 11.8955C5.08509 11.9112 5.78574 11.9167 6.50218 11.9167C7.17701 11.9167 7.86238 11.9112 8.56355 11.8955C9.47544 11.8798 10.0834 11.3073 10.1866 10.3643Z"
             fill="#E64A27"
            />
           </svg>
          </button>
         </div>
        </div>
        <p className="pt-2 pl-4 text-xs opacity-60">{notification.user_message}</p>
        <div className="border-b border mt-5"></div>
       </div>
      ))}
     </div>
    ) : (
     <div className="w-96 flex h-full justify-center items-center">
      <p>Notifications not found</p>
     </div>
    )}
   </ul>
  </Box>
 )
}
